import { useCurrentUser } from '@rover/rsdk/src/modules/Data/Core/CurrentUser';

const useIsBHUser = (): boolean => {
  const { user } = useCurrentUser();
  return user?.isBrightHorizonsUser ?? false;
};

export default useIsBHUser;
